/**
 * Quick "remind me" presets for follow-ups. Each computes a concrete `remindAt`
 * (ISO) from "now" plus a short label of when it lands, so the menu reads
 * "Через час · 15:30" without the user touching a date picker.
 */

export type RemindPresetKey = 'hour' | 'evening' | 'morning' | 'week';

/** Concrete reminder instant (ISO) for a preset. */
export function presetRemindAt(key: RemindPresetKey): Date {
  const d = new Date();
  switch (key) {
    case 'hour':
      d.setHours(d.getHours() + 1);
      return d;
    case 'evening': {
      const e = new Date();
      e.setHours(19, 0, 0, 0);
      // Past 19:00 already → tonight has gone, aim for tomorrow evening.
      if (e.getTime() <= Date.now()) e.setDate(e.getDate() + 1);
      return e;
    }
    case 'morning': {
      const m = new Date();
      m.setDate(m.getDate() + 1);
      m.setHours(9, 0, 0, 0);
      return m;
    }
    case 'week':
      d.setDate(d.getDate() + 7);
      return d;
  }
}

/** Short "when" label for a preset — time of day, or weekday+date for >1 day. */
export function presetSubLabel(key: RemindPresetKey): string {
  const at = presetRemindAt(key);
  if (key === 'week') {
    return at.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
  }
  return at.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
}
